import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-screenings',
  templateUrl: './screenings.component.html',
  styleUrls: ['./screenings.component.less']
})
export class ScreeningsComponent implements OnInit {
  clientId : number;
  constructor(private toast: ToastrService, private location: Router, private activatedRoute: ActivatedRoute,private users: UserService, private auth : AuthService) {
    this.auth.titleBarText = "Your Screenings";
    this.auth.roleFetchComplete.subscribe((dta: any)=>{
      console.log('roles fetched');
      // TODO : pass the status code so know if we should actually redirect(401).
      if(dta.status == 401)this.location.navigateByUrl('/auth');
      else if(dta.status == 500) this.toast.error(`error ${dta}`);
  });
   }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.clientId = parseInt(params.get('client'),10);
        this.auth.postLoginRedirect = '/screenings/list/'+this.clientId;
        if(!localStorage.getItem('STP-JWT')){
          this.auth.hasRedirect = true;
          this.location.navigateByUrl('/auth')
        }else {
          this.auth.GetUsersRoles();
          // this.clientSrv.FetchClientSearchPackages(this.clientId).subscribe((results : any)=>{
          //   this.packages = results.map((v) => {
          //     v.searches = v.searches;
          //     return v;
          //   });
          // });

          // this.clientSrv.FetchClientList().subscribe((results : any)=>{
          //   this.nonCraClients = results;
          //   console.log(this.nonCraClients)
          // });
        }
      });
  }

  createScreening(){
    this.location.navigateByUrl("/screenings/create/"+ this.clientId);
  }

}
